import React, { useCallback } from "react";
import client from "@culturehq/client";
import { Icon, PlainButton } from "@culturehq/components";

import { useProfile } from "app/context";
import { RecognitionLink } from "app/links";
import { canAdminRecognition, canApproveRecognition } from "app/permissions";
import { Trans } from "app/utils";

import Flag from "components/common/Flag";
import QuickOptions from "components/display/QuickOptions";

import PinUserActivityToggle from "components/feed/feed-item/PinUserActivityToggle";
import ChqModalConfirmDelete from "components/common/ChqModalConfirmDelete";

const RecognitionQuickLinks = ({
  onApprove = () => {}, onDelete, onUserActivityUpdate, recognition, sticky, userActivity
}) => {
  const { profile } = useProfile();

  const onDeleteAction = useCallback(
    async () => {
      await client.deleteRecognition({ recognitionId: recognition.id });
      onDelete();
    },
    [onDelete, recognition]
  );

  const onApproveAction = useCallback(
    async () => {
      await client.approveRecognition({ recognitionId: recognition.id });
      onApprove(recognition.id);
    },
    [onApprove, recognition]
  );

  return (
    <QuickOptions sticky={sticky}>
      <ul className="dropdown-menu">
        {profile.organizationAdmin && userActivity && (
          <li>
            <PinUserActivityToggle
              userActivity={userActivity}
              onUserActivityUpdate={onUserActivityUpdate}
            />
          </li>
        )}
        <li>
          <RecognitionLink recognition={recognition}>
            <Icon icon="megaphone" />
            <Trans>View this recognition</Trans>
          </RecognitionLink>
        </li>
        {canAdminRecognition(profile, recognition) && (
          <li>
            <ChqModalConfirmDelete
              onAccept={onDeleteAction}
              trigger={onTrigger => (
                <PlainButton onClick={onTrigger}>
                  <Icon icon="ios-trash" />
                  <Trans>Delete this recognition</Trans>
                </PlainButton>
              )}
            >
              <Trans>Are you sure you want to delete this recognition?</Trans>
            </ChqModalConfirmDelete>
          </li>
        )}
        <li>
          <Flag action="flagRecognition" options={{ recognitionId: recognition.id }}>
            {onTrigger => (
              <PlainButton onClick={onTrigger}>
                <Icon icon="ios-flag" />
                <Trans>Flag this recognition</Trans>
              </PlainButton>
            )}
          </Flag>
        </li>
        {canApproveRecognition(profile, recognition) && (
          <li>
            <PlainButton onClick={onApproveAction}>
              <Icon icon="checkmark" />
              <Trans>Approve</Trans>
            </PlainButton>
          </li>
        )}
      </ul>
    </QuickOptions>
  );
};

export default RecognitionQuickLinks;
